export const getters = {
  systemOccupations: state => state.occupations,
  Occupation: state => state.systemOccupation
};
export default getters;



// WEBPACK FOOTER //
// ./src/vuex/modules/occupations/getters.js